import React, {useRef, useState, useEffect} from 'react';
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {connect, useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

// components
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../../components/buttons/customButtons";
import Separator from "../../../../components/Separator";
import {getStateByPath} from "../../../../redux/selectors";

// labels
import { INTERNATIONAL, LB_ACTIVE, LB_CODE } from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_REMOVE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {PH_CODE} from "../../../../components/i18n/placeHolders";


// actions
import { setDataToEdit, setEditMode, setEnabledForm, setFormInfo } from "../../../../redux/actions/genericActions";

// providers

// utils

// services
import HomeCategorySectionLangs from "./_langs";
import SubCategorySection from "../subCategorySection/SubCategorySection";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {hotelCategoryService} from "../../../../jwt/_services/hotel/hotelCategoryService";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import ImagePicker from "../../../../components/imagePickerComponents/ImagePicker";
import {hotelCategoryMediaService} from "../../../../jwt/_services/core/hotelCategoryMediaService";
import {getCurrentDateForCodeField} from "../../../../util/DateTools";

const HomeCategorySectionForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, udn, editMode, domainObject, userIsAdmin } = componentState?.data;

    const [status, setStatus] = useState(domainObject?.status || true)
    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showModal, setShowModal] = useState(false)

    const modalRef = useRef(null);


    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: domainObject?.code,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: (domainObject?.code || `cat_` + getCurrentDateForCodeField()).toUpperCase(), // AUTOCODE
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: {id: app?.fbDataBase?.id},
            item: {
                ...data,
                code: data?.code,
                udn: { id : udn?.id },
                langs,
                status,
                showOrder: 0,
                showInHome : true,
                genericCategory: false,
            }
        }

        if(!data?.code || data?.code === "")
            dataRequest.item.code = `${udn?.code}_CAT_` + getCurrentDateForCodeField()

        if (!editMode)
            genericIndexedActions.save(path, hotelCategoryService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id
            genericIndexedActions.update(path, hotelCategoryService, id, dataRequest)
        }

        closeForm()
    };

    const setImageFile = (imageName) => {
        let img;

        try {
            img = require("../../../../assets/images/category/" + udn?.code?.toLowerCase() + "/" + imageName + ".jpg");
        } catch (_) {
            // img = require("../../../../assets/images/icon/parks/svg/gpoxc-icon.svg");
        }

        return img
    }

    const closeForm = () => props.onClose()

    const onRemoveItem = (item) => {
        genericIndexedActions.delete(path, hotelCategoryService, item.id, app?.fbDataBase?.id, closeForm);
    }

    const refreshObject = () => genericIndexedActions.get(path, hotelCategoryService, domainObject?.id, app?.fbDataBase?.id);


    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={ editMode ? 'card-modal-medium card-modal-height-large' : 'card-modal-small'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    {/*<h2 className={'card-modal-title'} > { (app?.name || '') + ' / ' + (udn?.value || '') + ' / ' + item?.title?.toUpperCase() || item?.name?.toUpperCase() || '' }</h2>*/}
                    <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <TranslateButton item={domainObject} service={hotelCategoryService} askForConfirmation={false}/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-trash'}
                        permission={'delete'}
                        onClick={() => onRemoveItem(domainObject)}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md={ editMode ? '6' : '12' }>
                        <Row>
                            {
                                userIsAdmin &&
                                <Col md="8">
                                    <FormGroup>
                                        <Label>{LB_CODE}</Label>
                                        <Input
                                            type="text"
                                            name="code"
                                            placeholder={PH_CODE}
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            }
                            <Col md="4">
                                <FormGroup>
                                    <Label>{LB_ACTIVE}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={() => setStatus(!status)}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={ "12" }>
                                <HomeCategorySectionLangs
                                    langs={langs}
                                    setLangs={setLangs}
                                    // translatableLangs={translatableLangs}
                                    isAdmin={userIsAdmin}
                                />
                                <br />
                            </Col>



                        </Row>
                    </Col>
                    <Col md={ editMode ? '6' : '0' }>
                        { domainObject?.id &&
                            <ImagePicker
                                className={'hotelCategory'}
                                title={'Hotel Media'}
                                app={app}
                                service={hotelCategoryService}
                                baseMediaService={hotelCategoryMediaService}
                                objectMedia={domainObject}
                                afterUpload={refreshObject}
                            />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md={ "12" }>
                        { editMode && <SubCategorySection path={path}/>}
                    </Col>
                </Row>


            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode,
})

export default connect(mapStateToProps, mapActionsToProps)(HomeCategorySectionForm)